import React from "react";

const TypingLoader= () => {
  return (
    <div className="flex items-center space-x-1">
      <span>Typing</span>
      <span style={{ ...styles.dot, animationDelay: "0s" }}>.</span>
      <span style={{ ...styles.dot, animationDelay: "0.2s" }}>.</span>
      <span style={{ ...styles.dot, animationDelay: "0.4s" }}>.</span>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: "flex",
    alignItems: "center",
    gap: "3px",
  },
  dot: {
    animation: "typingDots 1.5s infinite",
    opacity: 0,
  },
};

// Define keyframes as a global style
const globalStyle = `
@keyframes typingDots {
  0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
}
`;

// Inject styles into the document head
const styleSheet = document.createElement("style");
styleSheet.innerHTML = globalStyle;
document.head.appendChild(styleSheet);

export default TypingLoader;
